<template>
  <div class="check-work-body">
    <div>
      <div class="search-wrap">
        <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
      </div>

      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
          <el-table-column prop="id" label="id" align="center"></el-table-column>
          <el-table-column prop="name" label="名称" align="center" width="240"></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="180">
            <template slot-scope="scope">
              {{scope.row.status?'显示':'隐藏'}}
            </template>
          </el-table-column>

          <el-table-column prop="create_time" label="创建时间" align="center" width="180"></el-table-column>
          <el-table-column prop="update_time" label="修改时间" align="center" width="180"></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteCmsChannel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="类型名称" prop="title">
            <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="父级类型" prop="title">
<!--            flow_type_list-->
<!--            <el-input class="form-input" v-model="form.pid" autocomplete="off"></el-input>-->

            <el-select size="mini" v-model="form.pid" filterable placeholder="请选择">
              <el-option
                v-for="item in flow_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>

          </el-form-item>
          <el-form-item label="状态" prop="title">
            <el-radio v-model="form.status" label="1">显示</el-radio>
            <el-radio v-model="form.status" label="0">隐藏</el-radio>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import Http from "./common/Http";
import UploadFilesSysc from "./components/UploadFilesSysc";
import UploadFileSysc from "./components/UploadFileSysc";

export default {
  name:"FlowProfessionalType",
  components: {UploadFileSysc, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        pid:"",
        status:"",
      },
      uploadUrl:"",
      flow_type_list:[],
    }
  },
  created() {
    this.host_url=Http.getBaseURL();
    this.uploadUrl=this.host_url+"flow/FlowType/uploadFile";
    this.getParentList();
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        pid:"",
        name:"",
        status:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getParentList() {
      var that=this;
      let where={};
      Http.get("flow/FlowProfessionalType/getList",{
        where:JSON.stringify(where),
        field:"id,name",
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.flow_type_list=res.data.list
        }
      })
    },
    getList() {
      var that=this;
      that.loading=true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      Http.get("flow/FlowProfessionalType/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          res.data.list=res.data.list.map(ret=>{
            ret.status=!!ret.status;
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {
      if(!item) {
        this.form = this.getFormData({})
      } else {
        this.form = item
      }
      this.dialogVisible = true
    },

    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          data.status=data.status?1:0;
          Http.post("flow/FlowProfessionalType/save",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.getParentList();
              that.getList()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      const that = this;
      data.status=data.status?1:0;
      Http.post("flow/FlowProfessionalType/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getParentList();
          that.getList()
        }
      })
    },
    deleteCmsChannel(item){
      const that = this;
      Http.post("flow/FlowProfessionalType/delete", {id:item.id},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 200px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowProfessionalType.vue